import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { LoginPageContent, LoginPageContentMapped } from '@airtradeit/login-page/lib/_interfaces_/login-page.interface';
import { AuthenticationService } from '@airtradeit/authentication';
import { Store } from '@ngrx/store';

import { ContentService } from '@shared/services/content/content.service';
import { ContentTypesEnum } from '@enums/content-type.enum';
import { AppState } from '@store/state';
import * as fullscreenLoaderActions from '@store/fullscreen-loader/fullscreen-loader.actions';
import { AnalyticsService } from '@shared/services/analytics/analytics.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  content: LoginPageContentMapped;
  private unsubscribeAll$: Subject<void> = new Subject();

  constructor(
    @Inject(AuthenticationService) private _authService: AuthenticationService,
    @Inject(AnalyticsService) private _analyticsService: AnalyticsService,
    @Inject(TranslateService) private _translateService: TranslateService,
    @Inject(ContentService) private _contentService: ContentService,
    @Inject(Store) private _store: Store<AppState>
  ) {}

  ngOnInit(): void {
    this.getContent();
  }

  getContent(): void {
    this._contentService
      .getContent<LoginPageContent>(ContentTypesEnum.login)
      .pipe(takeUntil(this.unsubscribeAll$))
      .subscribe((content) => {
        this.content = this.mapLoginPageContent(content);
      });
  }

  login(): void {
    this._store.dispatch(fullscreenLoaderActions.setVisibility({ isVisible: true }));
    this._authService.logIn();
  }

  public mapLoginPageContent(response: LoginPageContent): LoginPageContentMapped {
    const mappedContent = response as any;
    mappedContent.bannerScreenshot = {
      url: mappedContent.bannerScreenshot.fields.file.url,
      title: mappedContent.bannerScreenshot.fields.title,
    };

    return mappedContent;
  }

  ngOnDestroy(): void {
    this.unsubscribeAll$.next();
    this.unsubscribeAll$.complete();
  }
}
